import {
  COLLECTION_MIS_REQUEST,
  COLLECTION_MIS_SUCCESS,
  COLLECTION_MIS_FAIL,
  COLLECTION_SUPERVISORS_REQUEST,
  COLLECTION_SUPERVISORS_SUCCESS,
  COLLECTION_SUPERVISORS_FAIL,
} from '../constants/collectionMisConstants';

export const collectionMisReducer = (state = { rows: [] }, action) => {
  switch (action.type) {
    case COLLECTION_MIS_REQUEST:
      return { loading: true, rows: [] };
    case COLLECTION_MIS_SUCCESS:
      return { loading: false, rows: action.payload };
    case COLLECTION_MIS_FAIL:
      return { loading: false, error: action.payload, rows: [] };
    default:
      return state;
  }
};

export const collectionSupervisorsReducer = (state = { supervisors: [] }, action) => {
  switch (action.type) {
    case COLLECTION_SUPERVISORS_REQUEST:
      return { loading: true, supervisors: [] };
    case COLLECTION_SUPERVISORS_SUCCESS:
      return { loading: false, supervisors: action.payload };
    case COLLECTION_SUPERVISORS_FAIL:
      return { loading: false, error: action.payload, supervisors: [] };
    default:
      return state;
  }
};
